import { useEffect, useState } from 'react';
import { Icon } from './ui';

interface InstallPrompt extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{outcome:'accepted'|'dismissed'}>;
}
let availablePrompt: InstallPrompt | undefined;
// Registered when the module loads, before the login screen can miss the event.
window.addEventListener('beforeinstallprompt',event=>{event.preventDefault();availablePrompt=event as InstallPrompt;window.dispatchEvent(new Event('tempo-install-ready'));});
export function InstallApp() {
  const [prompt,setPrompt]=useState(availablePrompt);
  const [installed,setInstalled]=useState(()=>matchMedia('(display-mode: standalone)').matches || Boolean((navigator as Navigator & {standalone?:boolean}).standalone));
  const [busy,setBusy]=useState(false);
  const [message,setMessage]=useState('');
  useEffect(()=>{
    const ready=()=>setPrompt(availablePrompt);
    const done=()=>{setInstalled(true);availablePrompt=undefined;setPrompt(undefined);};
    window.addEventListener('tempo-install-ready',ready);window.addEventListener('appinstalled',done);
    return()=>{window.removeEventListener('tempo-install-ready',ready);window.removeEventListener('appinstalled',done);};
  },[]);
  const install=async()=>{
    if(!prompt)return;setBusy(true);setMessage('');
    try{await prompt.prompt();const choice=await prompt.userChoice;setMessage(choice.outcome==='accepted'?'Permintaan instalasi diterima. Ikuti petunjuk browser.':'Bisa dipasang kapan saja melalui menu browser.');}
    catch{setMessage('Gunakan menu browser untuk memasang Tempo.');}
    finally{availablePrompt=undefined;setPrompt(undefined);setBusy(false);}
  };
  return <section className="install-card"><div className="inline-actions"><Icon name="home"/><strong>{installed?'Tempo dalam mode aplikasi':'Pasang Tempo di HP / desktop'}</strong></div>
    <p>Akses dari layar utama, tanpa mencari tab browser.</p>
    {!installed&&(prompt?<button className="btn primary full" disabled={busy} onClick={()=>void install()}>{busy?'Membuka instalasi…':'Pasang aplikasi'}</button>:<div className="install-instructions"><p><strong>Android / Chrome / Edge:</strong> buka menu ⋮ → Instal aplikasi atau Tambahkan ke layar utama.</p><p><strong>iPhone / iPad:</strong> buka di Safari → Bagikan → Tambahkan ke Layar Utama.</p></div>)}
    {message&&<p role="status">{message}</p>}
  </section>;
}
